import { render, staticRenderFns } from "./dirDialog.vue?vue&type=template&id=53e54b22&scoped=true"
import script from "./dirDialog.vue?vue&type=script&lang=js"
export * from "./dirDialog.vue?vue&type=script&lang=js"
import style0 from "./dirDialog.vue?vue&type=style&index=0&id=53e54b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e54b22",
  null
  
)

export default component.exports